module.exports = __webpack_public_path__ + "static/media/business.d996a035.png";